// JS file for SupplierList


